import { notesAndImagesVisibilityValues } from './RejectedProductsSection/constants'
import { sortingValues } from './SortingSettingsSection/constants'

export const getNotesAndImagesVisibility = showRejected => {
  return showRejected ? notesAndImagesVisibilityValues.visible : notesAndImagesVisibilityValues.hidden
}

export const getSortingValue = sorting => sorting || sortingValues.custom

export const getReturnReasonsSettingsPayload = returnPortalFeatures => {
  return {
    show_rejected: Boolean(returnPortalFeatures.show_rejected),
    return_reasons_sorting: getSortingValue(returnPortalFeatures.return_reasons_sorting),
    return_subreasons_sorting: getSortingValue(returnPortalFeatures.return_subreasons_sorting),
  }
}
